document.addEventListener('DOMContentLoaded', () => {
  // Главният бутон "Добави в количката" на продуктова страница
  const form = document.querySelector('.js-product-form-main');
  if (!form) return;

  const btn = form.querySelector('button[name="add"].btn');
  if (!btn) return;

  // леко забавяне, за да не „изскача“ грубо
  setTimeout(() => {
    btn.classList.add('btn--pulse');
  }, 400);

  // ако варианта стане изчерпан – махаме анимацията
  const observer = new MutationObserver(() => {
    if (btn.disabled) {
      btn.classList.remove('btn--pulse');
    } else {
      btn.classList.add('btn--pulse');
    }
  });

  observer.observe(btn, { attributes: true, attributeFilter: ['disabled'] });
});
